import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit {

  @ViewChild('picker') picker: any;

  @Input()
  public startDate: Date;
  @Output()
  public startDateChange = new EventEmitter<Date>();

  @Input()
  public min: Date;

  @Input()
  public endDate: Date;
  @Output()
  public endDateChange = new EventEmitter<Date>();

  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });

  constructor() {
  }

  ngOnInit() {
    
  }

  modelChanged($event) {
    this.startDateChange.emit(this.startDate);
    this.endDateChange.emit(this.endDate);
  }


}
